/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 21/2/2023
 */
import BaseObject from "@shared/BaseObject.js";
import AddressItem from "@shared/Profile/AddressItem";

export default class AdditionalInfoItem extends BaseObject {

	name: string = null
	email: string = null
	company: string = null
	primaryPhone: string = null
	primaryAddress: AddressItem = null
	consentAccepted: boolean = null

	collectName: boolean = true
	collectEmail: boolean = true
	collectCompany: boolean = false
	collectPhone: boolean = false
	collectAddress: boolean = false
	collectConsent: boolean = false
	consentText: string = null


	constructor() {
		super();
	}

	resetObject(){
		super.resetObject()
		this.name = null
		this.email = null
		this.company = null
		this.primaryPhone = null
		this.primaryAddress = null
	}

	isEnabled(){
		return this.collectCompany || this.collectPhone || this.collectAddress || (this.collectConsent && this.consentText)
	}
}
